const errorCache: any = {};

const getTranslationAddress = function (id: string, packageKey: string, sourceName: string) {
    if (id && id.indexOf(':') !== -1) {
        return id.split(':');
    }

    return [packageKey, sourceName, id];
};

/**
 * This code is taken from the Ember version with minor adjustments. Possibly refactor it later
 * as its style is not superb.
 */
const substitutePlaceholders = function (textWithPlaceholders: string, parameters: any) {
    const result = [];
    let startOfPlaceholder;
    let offset = 0;
    while ((startOfPlaceholder = textWithPlaceholders.indexOf('{', offset)) !== -1) {
        const endOfPlaceholder = textWithPlaceholders.indexOf('}', offset);
        const startOfNextPlaceholder = textWithPlaceholders.indexOf('{', startOfPlaceholder + 1);

        if (
            endOfPlaceholder === -1 ||
            startOfPlaceholder + 1 >= endOfPlaceholder ||
            (startOfNextPlaceholder !== -1 && startOfNextPlaceholder < endOfPlaceholder)
        ) {
            // There is no closing bracket, or it is placed before the opening bracket, or there is nothing between brackets
            console.error(
                "Text provided contains incorrectly formatted placeholders. Please make sure you conform the placeholder's syntax.",
            );
            break;
        }

        const contentBetweenBrackets = textWithPlaceholders.substr(
            startOfPlaceholder + 1,
            endOfPlaceholder - startOfPlaceholder - 1,
        );
        const placeholderElements = contentBetweenBrackets.replace(' ', '').split(',');

        const valueIndex = placeholderElements[0];
        const value = parameters[valueIndex];
        if (typeof value === 'undefined') {
            console.error(
                'Placeholder "' +
                    valueIndex +
                    '" was not provided, make sure you provide values for every placeholder.',
            );
            break;
        }

        let formattedPlaceholder;
        if (typeof placeholderElements[1] === 'undefined') {
            // No formatter defined, just string-cast the value
            formattedPlaceholder = parameters[valueIndex];
        } else {
            console.error('Placeholder formatter not supported.');
            break;
        }

        result.push(textWithPlaceholders.substr(offset, startOfPlaceholder - offset));
        result.push(formattedPlaceholder);

        offset = endOfPlaceholder + 1;
    }

    result.push(textWithPlaceholders.substr(offset));

    return result.join('');
};

const getPluralForm = (translation: string | string[] | Record<string, any>, quantity = 0): string => {
    const translationHasPlurals = Array.isArray(translation);

    // no defined quantity or less than one returns singular
    if (translationHasPlurals && (!quantity || quantity < 1)) {
        return translation[0];
    }

    if (translationHasPlurals && quantity === 1) {
        return translation[1] ? translation[1] : translation[0];
    }

    if (translationHasPlurals && quantity > 1) {
        return translation[2] ? translation[2] : translation[0];
    }

    return String(translation);
};

type i18nInput = {
    id: string;
    fallback: string;
    params: Record<string, string>;
    packageKey: string;
    sourceName: string;
    quantity: number;
};
export default class I18nService {
    _translations: Record<string, any> = {};

    setTranslations(translations: any[]) {
        this._translations = translations;
    }

    translate({
        id,
        fallback,
        params = {},
        packageKey = 'Avency.BotAPI',
        sourceName = 'Main',
        quantity = 0,
    }: i18nInput): string {
        const fallbackInternal = fallback || id;
        const [packageKeyInternal, sourceNameInternal, idInternal] = getTranslationAddress(id, packageKey, sourceName);

        let result = [packageKeyInternal, sourceNameInternal, idInternal]
            .map((s) => (s ? s.replace(/\./g, '_') : ''))
            .reduce(
                (prev: Record<string, any>, cur: string) => (prev && cur in prev ? prev[cur] || '' : ''),
                this._translations,
            );

        const translation = getPluralForm(result, quantity);

        if (translation && translation.length) {
            if (Object.keys(params).length) {
                return substitutePlaceholders(translation, params);
            }
            return translation;
        }

        if (!errorCache[`${packageKeyInternal}:${sourceNameInternal}:${idInternal}`]) {
            console.error(
                `No translation found for id "${packageKeyInternal}:${sourceNameInternal}:${idInternal}" in:`,
                this._translations,
                `Using ${fallbackInternal} instead.`,
            );

            errorCache[`${packageKeyInternal}:${sourceNameInternal}:${idInternal}`] = true;
        }

        return fallbackInternal;
    }
}
